module.exports = __webpack_public_path__ + "static/media/LOGO_BLANCO.f41cbff9.svg";